import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { UserCombi } from "../../../../model";

@Component({
  standalone: false,
  selector: 'app-usercombi-from-to',
  templateUrl: './usercombi-from-to.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserCombiFromToComponent {
  readonly userCombi = input.required<UserCombi>();
}
